<template>
  <div class="contact">
    <head>
      <title>Contact Us - inte-QT</title>
      <meta name="title" content="Contact Us - inte-QT" />
      <meta name="description" content="For any kind of support you may need" />
      <link rel="canonical" href="https://www.inte-qt.com/contact" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <link rel="stylesheet" href="@/assets/css/contactpage.css" />
    </head>

    <h1 class="text-center mx-auto center-header contact__title">
      What kind of support do you need?
    </h1>

    <div class="row contact__box">
      <div class="col-lg-4 col-md-6 col-sm-12 contact__card">
        <router-link to="/contact/support" class="contact__link">
          <h3 class="contact__card-title">Support</h3>
          <p>For current inte-QT customers with inquiries about their connection</p>
        </router-link>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-12 contact__card">
        <router-link to="/contact/sales" class="contact__link">
          <h3 class="contact__card-title">Sales</h3>
          <p>For inquiries related to acquiring connections and internet plans</p>
        </router-link>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-12 contact__card">
        <router-link to="/contact/general" class="contact__link">
          <h3 class="contact__card-title">General</h3>
          <p>For all inquiries unrelated to Sales and Support</p>
        </router-link>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-6 col-md-12">
        <ContactMap />
      </div>
      <div class="col-lg-6 col-md-12 contact__font text-start">
        <h3>Contact Information</h3>
        <p class="text-start">If you wish to contact us in usual ways.</p>
        <hr />

        <div class="row">
          <div class="col-md-12 text-center mb-4">
            <h5 class="m-4">EUROPE</h5>
          </div>
          <div class="col-md-6 mb-4">
            <div>
              <h6 class="blue mt-3">COMPANY HEADQUARTERS</h6>
              <p>INTELLIGENT QUOTING TECHNOLOGY, S.L.</p>
              <p>Calle de Manzanares, 4</p>
              <p>28005 Madrid</p>
              <p>SPAIN</p>
              
              <p>
                <i class="fas fa-phone-alt mx-2"></i>
                <a href="tel:+34620959970" class="text-decoration-none blue">
                  (+34) 620 95 99 70
                </a>
              </p>
            </div>
          </div>
          <div class="col-md-6 mb-4">
            <div>
              <h6 class="blue mt-3">REGIONAL SALES OFFICE</h6>
              <p>INTELLIGENT QUOTING TECHNOLOGY S.L., GLOBAL SALES</p>
              <p>Av. Rey Juan Carlos I, 90</p>
              <p>28916  Madrid</p>
              <p>SPAIN</p>
            
              <p>
                <i class="fas fa-phone-alt mx-2"></i>
                <a href="tel:+34620959970" class="text-decoration-none blue">
                  (+34) 620 95 99 70
                </a>
              </p>
            </div>
          </div>
        </div>

        <div class="mb-3">
          <h5 class="m-4 text-center">ASIA</h5>
          <h6 class="blue mt-3">INDIA REGIONAL OFFICE</h6>
          <p>inte-QT</p>
          <p>Jaipur 302019</p>
          <p>INDIA</p>
         
          <p>
            <i class="fas fa-phone-alt mx-2"></i>
            <a href="tel:+917208088770" class="text-decoration-none blue">
              (+91) 720 808 8770
            </a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContactMap from '@/components/ContactMap.vue'

export default {
  name: 'ContactPage',
  components: {
    ContactMap
  },
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>

<style scoped>
.contact {
  padding: 20px;
}

.contact__title {
  text-align: center;
    margin-top: 20px;
    padding: 40px;
    font-size: 3.5rem;
    font-weight: 300;
}

.contact__box {
    display: flex;
    justify-content: center;
    margin-bottom: 5rem;
    padding: 1rem;
}

.contact__card {
  padding: 20px;
  border-radius: 16px;
  background-color: #f5f8ff;
  transition: all 0.3s ease;
  cursor: pointer;
  height: 100%;
  margin: 2rem;
}

.contact__card:hover {
  background-color: #e0ebff;
  box-shadow: 0 4px 20px rgba(0, 96, 255, 0.2);
}

.contact__link {
  text-decoration: none;
  color: #003366;
  display: block;
  height: 100%;
}

.contact__card:hover .contact__card-title,
.contact__card:hover p {
  color: #0033cc;
}

.contact__font {
  font-size: 1.1em;
}

.text-start {
  text-align: left;
}

.blue {
  color: #007bff;
}

i {
  font-size: 1.2em;
}
</style>
